import React, { useEffect, useState, memo } from 'react';
import './PGDetails.css';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  doc, getDoc, setDoc, deleteDoc, collection, getDocs, onSnapshot, runTransaction, increment, serverTimestamp 
} from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import { db, storage, auth } from './firebase';
import { useAuth } from '../context/AuthContext';
import ContactOwnerForm from "./ContactOwnerForm";
import { FaHeart, FaStar, FaWifi, FaTv, FaHome, FaCheckCircle, FaCamera, FaFan, FaCar, FaPaw,FaRoad , FaFire, FaArrowUp, FaSwimmingPool } from "react-icons/fa";
import { MdFastfood, MdKitchen, MdOutlineWaterDrop } from 'react-icons/md';
import { BiFridge } from 'react-icons/bi';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';


const amenityIcons = {
  "electric backup": <FaCheckCircle />,
  "water supply": <MdOutlineWaterDrop />,
  "fans and lighting": <FaFan />,
  "modular kitchen": <MdKitchen />,
  "wardrobes": <FaHome />,
  "security": <FaCamera />,
  "lift/elevator": <FaArrowUp />,
  "parking": <FaCar />,
  "balcony": <FaHome />,
  "swimming pool": <FaSwimmingPool />,
  "pet friendly": <FaPaw />,
  "gas pipeline": <FaFire />
};

const UNLOCK_DURATION = 30 * 60 * 1000;





const optimizeImage200kb = (url, targetKB = 200) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = url;
    img.onload = () => {
      let width = img.width;
      let height = img.height;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      let quality = 0.9;
      const step = 0.05;
      const compress = () => {
        canvas.toBlob((blob) => {
          if (blob.size / 1024 <= targetKB || quality <= 0.1) {
            resolve(URL.createObjectURL(blob));
          } else {
            quality -= step;
            compress();
          }
        }, "image/jpeg", quality);
      };
      compress();
    };
    img.onerror = () => resolve(url);
  });
};



const RentDetails = () => {
  const [listingData, setListingData] = useState(null);
  const [sliderItems, setSliderItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [cityState, setCityState] = useState('');
  const [exactLocation, setExactLocation] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const [tokens, setTokens] = useState(0);
  const [isButtonUnlocked, setIsButtonUnlocked] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [avgRating, setAvgRating] = useState(0);
  const [ratingCount, setRatingCount] = useState(0);
  const [userRating, setUserRating] = useState(0);
  const [showContactForm, setShowContactForm] = useState(false);



  const { currentUser } = useAuth();
  const { listingId } = useParams();
  const navigate = useNavigate();
const [coordinates, setCoordinates] = useState(null);
  const capitalizeWords = str => str.replace(/\b\w/g, char => char.toUpperCase());
  const formatTime = ms => { const s=Math.floor(ms/1000); return `${Math.floor(s/60)}m ${s%60}s`; };


  // Nearby student essentials

const getDistanceKm = (lat1, lng1, lat2, lng2) => {
  const toRad = x => x * Math.PI / 180;
  const R = 6371; // Earth radius in km
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat/2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng/2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};



useEffect(() => {
  // Disable right-click and context menu
  const handleContextMenu = (e) => e.preventDefault();
  const handleKeyDown = (e) => {
    if (
      e.key === "PrintScreen" ||
      (e.ctrlKey && (e.key === "s" || e.key === "u" || e.key === "p"))
    ) {
      e.preventDefault();
      alert("Screenshots and saving are disabled on this page.");
    }
  };
  const handleDragStart = (e) => e.preventDefault();

  document.addEventListener("contextmenu", handleContextMenu);
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("dragstart", handleDragStart);

  // Disable long-press saving on mobile
  let touchTimer;
  const handleTouchStart = (e) => {
    touchTimer = setTimeout(() => {
      e.preventDefault();
     
    }, 400);
  };
  const handleTouchEnd = () => clearTimeout(touchTimer);

  document.addEventListener("touchstart", handleTouchStart, { passive: false });
  document.addEventListener("touchend", handleTouchEnd);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
    document.removeEventListener("keydown", handleKeyDown);
    document.removeEventListener("dragstart", handleDragStart);
    document.removeEventListener("touchstart", handleTouchStart);
    document.removeEventListener("touchend", handleTouchEnd);
  };
}, []);

  useEffect(()=>{
    const fetchListing = async()=>{
      try{
        const docSnap = await getDoc(doc(db,'rent-listings',listingId));
        if(!docSnap.exists()) return;
        const data = {id:docSnap.id,...docSnap.data()};
        setListingData(data);
if (data.fullAddress) {
  setExactLocation(data.fullAddress);
} else {
  setExactLocation("Address not available");
}

        const thumbURL = data.thumbnailPath 
          ? await optimizeImage200kb(await getDownloadURL(ref(storage,data.thumbnailPath)))
          : '';
        const slotURLs = data.slotImagePaths 
          ? await Promise.all(data.slotImagePaths.map(async p=>({type:'image', url: await optimizeImage200kb(await getDownloadURL(ref(storage,p)))})))
          : [];
        const mediaItems = [{type:'image', url:thumbURL}, ...slotURLs];

        if(data.videoPath){
          try{
            const videoURL = await getDownloadURL(ref(storage,data.videoPath));
            mediaItems.push({type:'video', url:videoURL});
          } catch(e){ console.warn('Video load failed'); }
        }

        setSliderItems(mediaItems);
        setActiveIndex(0);
       
        await loadRatings(data.id);
      } catch(e){ console.error(e); }
    };
    fetchListing();
  }, [listingId]);





  const loadRatings = async (id)=>{
    try{
      const ratingsSnap = await getDocs(collection(db,'rent-listings',id,'ratings'));
      let sum=0,count=0,myRating=0;
      ratingsSnap.forEach(d=>{
        const val=d.data()?.value;
        if(typeof val==='number'){sum+=val; count++;}
        if(auth.currentUser?.uid===d.id) myRating=val||0;
      });
      const avg=count?sum/count:0;
      setAvgRating(avg); setRatingCount(count); setUserRating(myRating);
      await setDoc(doc(db,'rent-listings',id),{ratingAvg:avg,ratingCount:count},{merge:true});
    } catch(e){ console.error(e); }
  };

  const handleRate=async(value)=>{
    if(!currentUser) return alert("Please log in to rate.");
    try{
      await setDoc(doc(db,'rent-listings',listingId,'ratings',currentUser.uid),{
        value,userId:currentUser.uid,ratedAt:new Date().toISOString()
      },{merge:true});
      setUserRating(value);
      await loadRatings(listingId);
    }catch(e){ console.error(e); alert("Could not submit rating."); }
  };


  useEffect(()=>{if(!currentUser) return onSnapshot(doc(db,"user-data",currentUser.uid),snap=>snap.exists()&&setTokens(snap.data().tokens||0));},[currentUser]);

  useEffect(()=>{
    const unlockKey=`pg_unlock_${listingId}`;
    const unlockTime=parseInt(localStorage.getItem(unlockKey)||"0",10);
    const now=Date.now();
    if(unlockTime && now-unlockTime<UNLOCK_DURATION){ setIsButtonUnlocked(true); setRemainingTime(UNLOCK_DURATION-(now-unlockTime)); }
    else { setIsButtonUnlocked(false); setRemainingTime(0); localStorage.removeItem(unlockKey); }
  },[listingId]);

  const getEmbeddedMapSrc=(mapLink)=>{ try{return `https://maps.google.com/maps?q=${new URL(mapLink).searchParams.get('q')}&z=15&output=embed`; }catch{return null;} };

useEffect(() => {
  const checkSaved = async () => {
    try {
      // Make sure both user and listingId exist before calling Firestore
      if (!currentUser?.uid || !listingId) {
        console.warn("Skipping checkSaved: missing user or listingId");
        return;
      }

      const savedRef = doc(db, "users", currentUser.uid, "saved-properties", listingId);
      const snap = await getDoc(savedRef);
      setIsSaved(snap.exists());
    } catch (error) {
      console.error("Error checking saved property:", error);
      setIsSaved(false);
    }
  };

  checkSaved();
}, [listingId, currentUser]);


  const toggleSaveProperty=async()=>{
    if(!currentUser) return alert("Please login to save property.");
    const refDoc=doc(db,"users",currentUser.uid,"saved-properties",listingId);
    try{
      if(isSaved){ await deleteDoc(refDoc); setIsSaved(false); }
      else{
        const thumbURL=listingData.thumbnailPath?await getDownloadURL(ref(storage,listingData.thumbnailPath)):'';
        await setDoc(refDoc,{...listingData,thumbnailURL:thumbURL,exactLocation,city:cityState,ratingAvg:avgRating,ratingCount,userId:currentUser.uid,saved:true,savedAt:new Date().toISOString(),type: "rent"});
        setIsSaved(true);
      }
    }catch(e){ console.error(e); alert("Could not save property."); }
  };

  const handleContactOwner=async()=>{
    if(!currentUser) return alert("Please login to contact the owner.");
    const unlockKey=`pg_unlock_${listingId}`;
    const now=Date.now();
    try{
      const unlockRef=doc(db,"user-data",currentUser.uid,"contact-unlocks",listingId);
      const unlockSnap=await getDoc(unlockRef);
      if(unlockSnap.exists() && now-unlockSnap.data().unlockedAt<UNLOCK_DURATION){
        setIsButtonUnlocked(true); setRemainingTime(UNLOCK_DURATION-(now-unlockSnap.data().unlockedAt));
        return navigate(`/owner/${listingData.ownerId}/${listingId}`);
      }
      const userRef=doc(db,"user-data",currentUser.uid);
 await runTransaction(db, async transaction => {
  const snap = await transaction.get(userRef);
  if (!snap.exists()) throw new Error("User not found");
  const currentTokens = snap.data().tokens || 0;
  if (currentTokens < 5) throw new Error("Need at least 5 tokens");

  const newTokens = Math.max(currentTokens - 5, 0);
  transaction.update(userRef, { tokens: newTokens });
  setTokens(newTokens); // update local state immediately
});

      await setDoc(unlockRef,{unlockedAt:now},{merge:true});
      localStorage.setItem(unlockKey,now.toString());
      setIsButtonUnlocked(true);
      await setDoc(doc(db,"ownerInbox",listingData.ownerId,"messages",`${currentUser.uid}_${Date.now()}`),{
        fromUser:currentUser.uid,listingId,type:"contact_request",createdAt:serverTimestamp(),seen:false
      });
      navigate(`/owner/${listingData.ownerId}/${listingId}`);
    }catch(e){ console.error(e); alert(e.message); }
  };

  if (!listingData) return <div>Loading...</div>;

// Destructure listingData safely
const { 
  pgName, 
  description, 
  rent, 
  amenities: rawAmenities = [], 
  occupancy, 
  roomType, 
  negotiable, 
  deposit 
} = listingData;

// Then normalize
const normalizedAmenities = Array.isArray(rawAmenities)
  ? rawAmenities.map(str => str?.toLowerCase()?.replace(/[_&]/g, " and ")?.trim())
  : [];

  const mapSrc=getEmbeddedMapSrc(listingData.mapLink);

  const renderActiveSliderItem=()=>{
    const active=sliderItems[activeIndex];
    if(!active) return null;
    if(active.type==='video') return <video src={active.url} controls style={{width:'100%',borderRadius:'12px'}} />;
    return (
      <div className="img-block">
        <img src={active.url} alt="Main" className="main-image"
          onContextMenu={(e)=>e.preventDefault()}
          onDragStart={(e)=>e.preventDefault()}
        />
        <div className="save-heart-btn-wrapper">
          <button onClick={toggleSaveProperty} className="save-heart-btn">
            <FaHeart size={20} color={isSaved?"red":"gray"} />
          </button>
        </div>
      </div>
    );
  };
const getCategoryEmoji = (category) => {
  const icons = {
    universities: "🎓",
    colleges: "🏫",
    cafes: "☕",
    restaurants: "🍽️",
    hospitals: "🏥",
    gyms: "💪",
    malls: "🏬",
    roads: "🛣️", // ✅ new icon for roads
  };
  return icons[category] || "📍";
};

  return (
    <div className="pg-detail-card">
      <button className="back-button" onClick={()=>navigate(-1)}>← Back</button>
      <div className="pg-image-gallery">
        <div className="main-image-wrapper">{renderActiveSliderItem()}</div>
        <div className="thumbnail-row">
          {sliderItems.map((item,idx)=>item.type==='image' ? (
            <img key={idx} src={item.url} alt={`Thumb ${idx}`} className={`thumbnail ${activeIndex===idx?'active-thumb':''}`}
              onClick={()=>setActiveIndex(idx)}
              onContextMenu={(e)=>e.preventDefault()}
              onDragStart={(e)=>e.preventDefault()}
            />
          ):(
            <div key={idx} className={`thumbnail video-thumb ${activeIndex===idx?'active-thumb':''}`} onClick={()=>setActiveIndex(idx)} title="Video"/>
          ))}
        </div>
      </div>
      {/* Info Section */}
      <div className="pg-info-section">
        <h2 className="pg-title">{pgName}</h2>
        <div style={{display:'flex',alignItems:'center',gap:10,marginTop:8}}>
          <div style={{fontSize:'0.95rem',color:'#333'}}><strong>{avgRating.toFixed(1)}</strong> / 5 <span style={{color:'#777'}}>({ratingCount})</span></div>
          <div style={{display:'flex',gap:4}}>
            {[1,2,3,4,5].map(n=>(
              <button key={n} onClick={()=>handleRate(n)} style={{background:'transparent',border:'none',cursor:'pointer',padding:0,lineHeight:0}}>
                <FaStar size={18} color={n<=(userRating||Math.round(avgRating))?'#f5c518':'#d0d0d0'} />
              </button>
            ))}
          </div>
        </div>
      </div>
      <p className="pg-exact"><FaHome style={{marginRight:'6px'}} />{exactLocation}</p>
      <h4>Description</h4>
      <div className="pg-description-section"><p>{description}</p></div>
      <div className="pg-title-row">
        <div className="pg-room-info-cards">
          <div className="info-card"><strong>Occupancy</strong><p>{occupancy}</p></div>
          <div className="info-card"><strong>Room Type</strong><p>{roomType}</p></div>
        </div>
        <div className="amenities-section">
          <h4 className="amenities-heading">Amenities</h4>
   <div className="amenity-icons">
    {normalizedAmenities
      .filter((a) => amenityIcons[a])   // only show valid icons
      .map((key) => (
        <div key={key} className="amenity-item active">
          {amenityIcons[key]} <span>{capitalizeWords(key)}</span>
        </div>
      ))
    }
  </div>



        </div>
        <div className="pg-price-info">
          <div className="price-row"><span>💸 <strong>Rent:</strong></span> <span>₹{rent}/month</span></div>
          <div className="price-row"><span>🤝 <strong>Negotiable:</strong></span> <span>{negotiable?'Yes':'No'}</span></div>
          <div className="price-row"><span>🔐 <strong>Deposit:</strong></span> <span>{deposit}</span></div>
        </div>

        {mapSrc ? <iframe src={mapSrc} width="100%" height="150" style={{border:0,borderRadius:'12px'}} loading="lazy" allowFullScreen title="Map"/> : <p style={{color:'gray', fontStyle:'italic'}}>Map not available</p>}
     

       
        <div className="owner-contact-section">
          <h4>Contact Owner</h4>
          {isButtonUnlocked && remainingTime>0 && <p style={{color:'green', fontWeight:'bold', marginBottom:'6px'}}>Unlock ends in: {formatTime(remainingTime)}</p>}
          <button className={`contact-owner-button ${isButtonUnlocked?"unlocked":"locked"}`} onClick={handleContactOwner}>
            {isButtonUnlocked?"📞 Contact Owner":`Unlock for 5 Tokens `}
          </button>
          <button className="notify-owner-button" disabled={remainingTime>0} onClick={()=>setShowContactForm(true)}>
            📩 Notify the Owner {remainingTime>0 && `(${Math.ceil(remainingTime/1000)}s)`}
          </button>
        </div>
        {showContactForm && <ContactOwnerForm ownerId={listingData.ownerId} listingId={listingId} onClose={()=>setShowContactForm(false)} />}
      </div>
    </div>
  );
};

export default memo(RentDetails);
